import React from "react";

const News = () => {
    return (
        <div>
            <h1>News</h1>
            <p>Welcome to the News page.</p>
        </div>
    );
};

export default News;